// src/pages/JourneyMap/phases/Step3Refine.jsx
// Passo 3 — REFINO: seleciona estilo visual, tom e destino do CTA
import React, { useState } from 'react';
import EdyAssistant from '../components/EdyAssistant';
import apiClient from '../../../lib/apiClient';

const VISUAL_STYLES = [
  { value: 'mais colorido',     label: 'Mais colorido'     },
  { value: 'mais minimalista',  label: 'Mais minimalista'  },
  { value: 'mais profissional', label: 'Mais profissional' },
];
const TONES = [
  { value: 'urgente',     label: 'Urgente'      },
  { value: 'amigável',    label: 'Amigável'     },
  { value: 'motivacional',label: 'Motivacional' },
];
const CTA_DESTINATIONS = [
  { value: 'whatsapp',   label: 'WhatsApp'   },
  { value: 'site',       label: 'Site / Link' },
  { value: 'instagram',  label: 'Instagram'   },
  { value: 'telefone',   label: 'Telefone'    },
];

function OptionGrid({ title, options, selected, onSelect }) {
  return (
    <div className="jm-refine-section" style={{ marginBottom: 20 }}>
      <p className="jm-refine-label">{title}</p>
      <div className="jm-refine-grid">
        {options.map(o => (
          <button
            key={o.value}
            className={`jm-refine-option${selected === o.value ? ' active' : ''}`}
            onClick={() => onSelect(o.value)}
          >
            <span className="jm-refine-text">{o.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default function Step3Refine({ campaignId, onAdvance }) {
  const [visualStyle,    setVisualStyle]    = useState('');
  const [tone,           setTone]           = useState('');
  const [ctaDestination, setCtaDestination] = useState('');
  const [saving,         setSaving]         = useState(false);
  const [error,          setError]          = useState('');

  const allSelected = visualStyle && tone && ctaDestination;

  const edyMsg = allSelected
    ? 'Perfeito! Seu anúncio está personalizado e pronto pra arrasar'
    : 'Escolha o estilo, o tom e pra onde seu público vai clicar!';
  const edyMood = allSelected ? 'joinha' : 'think';

  const handleConfirm = async () => {
    if (!allSelected) { setError('Selecione as três opções acima.'); return; }
    setSaving(true);
    setError('');
    try {
      const r = await apiClient.request(`/mp/journey/${campaignId}/refine`, {
        method: 'PUT',
        body:   JSON.stringify({ cta_destination: ctaDestination, tone, visual_style: visualStyle }),
      });
      const d = await r.json();
      if (d.success) {
        onAdvance(d.campaign);
      } else {
        setError(d.message || 'Erro ao salvar refinamentos.');
      }
    } catch {
      setError('Erro de conexão.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="jm-container">
      <EdyAssistant message={edyMsg} mood={edyMood} />

      <div className="jm-card">
        <OptionGrid
          title="Estilo visual"
          options={VISUAL_STYLES}
          selected={visualStyle}
          onSelect={setVisualStyle}
        />
        <OptionGrid
          title="Tom da mensagem"
          options={TONES}
          selected={tone}
          onSelect={setTone}
        />
        <OptionGrid
          title="Destino do CTA"
          options={CTA_DESTINATIONS}
          selected={ctaDestination}
          onSelect={setCtaDestination}
        />

        {error && <p style={{ color: 'var(--edy-red)', fontSize: '0.82rem', marginBottom: 10 }}>{error}</p>}

        <button
          className={`jm-btn-cta jm-btn-full${!allSelected ? ' disabled' : ''}`}
          onClick={handleConfirm}
          disabled={!allSelected || saving}
        >
          {saving ? 'Salvando...' : 'Confirmar refinamentos →'}
        </button>
      </div>
    </div>
  );
}
